export const rsFoulSewers = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "ADOPTED SEWERS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "956",
    Unit: "m",
    Rate: "n/a",
    Amount: "£170,215.37",
  },
  {
    Item: "",
    Description: "EO for 150mmØ stub/rocker pipe",
    Qty: "73",
    Unit: "nr",
    Rate: "21.76",
    Amount: "£1,588.48",
  },
  {
    Item: "",
    Description: "EO for impermeable geotextile membrane wrap to 150mmØ pipe",
    Qty: "114",
    Unit: "m",
    Rate: "5.53",
    Amount: "£630.42",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "LATERALS CONNECTIONS - PROVISIONAL SUM, NO LEVELS INFO",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipework, GBS, backfilled with 6F2, deposit surplus material on site ",
    Qty: "267",
    Unit: "m",
    Rate: "n/a",
    Amount: "£34,716.14",
  },
  {
    Item: "",
    Description: "EO for 150mmØ stub/rocker pipe",
    Qty: "78",
    Unit: "nr",
    Rate: "21.76",
    Amount: "£1,697.28",
  },
  {
    Item: "",
    Description: "EO for concrete bed & surround to 150mmØ pipe",
    Qty: "",
    Unit: "m",
    Rate: "33.04",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.0",
    Description: "MANHOLES",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm diameter manhole - PCC chamber rings",
    Qty: "37",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£100,279.02",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply and fit temporary debris grille to outfall manhole",
    Qty: "1",
    Unit: "nr",
    Rate: "1502.48",
    Amount: "£1,502.48",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.0",
    Description: "DEMARCATION CHAMBERS - PROVISIONAL SUM, NO LEVELS INFO",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Demarcation chamber - NME PPIC - 1.2 - 3.0m deep",
    Qty: "39",
    Unit: "nr",
    Rate: "964.80",
    Amount: "£37,627.20",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "5.0",
    Description: "TESTING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Clegg monitor testing of sewer backfill (500mm layer depths at 30 metre intervals)",
    Qty: "1",
    Unit: "item",
    Rate: "10582.65",
    Amount: "£10,582.65",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£358,839.04",
  },
];
